import React from 'react'

function Accessories() {
    return (
        <div>
            it is working
        </div>
    )
}

export default Accessories
